var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shadow-box-title-description"},[(_vm.title)?_c('ShadowBox',{staticClass:"shadow-box",class:{'left_text': _vm.isLeftText, 'sp_font_size': _vm.isSpFontSize, 'add_padding_left': _vm.addPaddingLeft},attrs:{"opacity":"_60"}},[_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.title))])]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }